// extracted by mini-css-extract-plugin
export default {"lottieContainer":"styles_lottieContainer__IV5iU","loading":"styles_loading__0HJN2"};